import axios from "axios";
import { BASE_URL } from "../constants";

export const refreshToken = async () => {
  try {
    const response = await axios.post(`${BASE_URL}auth/refresh/`, {
      refresh: localStorage.getItem("refresh_token"),
    });
    const newAccessToken = response.data.access;
    localStorage.setItem("access_token", newAccessToken);
    return newAccessToken;
  } catch (err) {
    console.error("Refresh token failed", err);
    throw err;
  }
};
